import { render } from "./reset-password-form.vue?vue&type=template&id=f00e315c"
import script from "./reset-password-form.vue?vue&type=script&lang=js"
export * from "./reset-password-form.vue?vue&type=script&lang=js"

import "./reset-password-form.vue?vue&type=style&index=0&id=f00e315c&lang=scss"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__